// src/pages/DashboardNavigation/components/StepButton.jsx

import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function StepButton({ direction, page, onClick }) {
  const isPrevious = direction === "previous";
  const disabled = !page;

  const Icon = isPrevious ? FaArrowLeft : FaArrowRight;
  const title = isPrevious ? "Précédent" : "Suivant";
  const fallbackLabel = isPrevious ? "Début du parcours" : "Fin du parcours";

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      title={disabled ? title : `${title} : ${page.label}`}
      aria-label={disabled ? title : `${title} : ${page.label}`}
      className={[
        "group flex min-h-[64px] items-center gap-2 rounded-2xl px-2.5 py-2 transition active:scale-[0.98] sm:px-3",
        isPrevious ? "justify-start text-left" : "justify-end text-right",
        disabled
          ? "cursor-not-allowed bg-slate-50 text-slate-300 ring-1 ring-slate-200/70 dark:bg-slate-950/60 dark:text-slate-700 dark:ring-slate-800"
          : isPrevious
          ? "bg-orange-50 text-orange-950 ring-1 ring-orange-200 hover:bg-orange-100 dark:bg-orange-950/25 dark:text-orange-100 dark:ring-orange-900/70 dark:hover:bg-orange-950/40"
          : "bg-sky-50 text-sky-950 ring-1 ring-sky-200 hover:bg-sky-100 dark:bg-sky-950/25 dark:text-sky-100 dark:ring-sky-900/70 dark:hover:bg-sky-950/40",
      ].join(" ")}
    >
      {isPrevious && (
        <span
          className={[
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-sm transition",
            disabled
              ? "bg-slate-100 text-slate-300 dark:bg-slate-900 dark:text-slate-700"
              : "bg-white/80 text-orange-700 shadow-sm dark:bg-orange-900/40 dark:text-orange-100",
          ].join(" ")}
        >
          <Icon />
        </span>
      )}

      <span className="min-w-0">
        <span
          className={[
            "block text-[9px] font-bold uppercase tracking-[0.14em]",
            disabled
              ? "text-slate-300 dark:text-slate-700"
              : isPrevious
              ? "text-orange-500 dark:text-orange-300"
              : "text-sky-500 dark:text-sky-300",
          ].join(" ")}
        >
          {title}
        </span>

        <span className="mt-0.5 block max-w-[105px] truncate text-xs font-bold sm:max-w-[190px] sm:text-sm">
          {page?.label || fallbackLabel}
        </span>

        {page?.groupTitle && (
          <span className="mt-0.5 hidden max-w-[190px] truncate text-[11px] font-medium opacity-70 sm:block">
            {page.groupTitle}
          </span>
        )}
      </span>

      {!isPrevious && (
        <span
          className={[
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-sm transition",
            disabled
              ? "bg-slate-100 text-slate-300 dark:bg-slate-900 dark:text-slate-700"
              : "bg-white/80 text-sky-700 shadow-sm dark:bg-sky-900/40 dark:text-sky-100",
          ].join(" ")}
        >
          <Icon />
        </span>
      )}
    </button>
  );
}